// extracted by mini-css-extract-plugin
module.exports = {"item":"EmailListItem_item__W2nIo","message":"EmailListItem_message__f_ivE","unread":"EmailListItem_unread__1J_Fe","read":"EmailListItem_read__jtMe4"};